module.exports = __webpack_public_path__ + "static/media/inf_80og81.8610c8f8.mp3";